import { useSelector } from 'react-redux';

import { openCurityPopup } from 'src/services/session/curityLogin';
import { deleteSession } from 'src/services/session/store';
import store from 'src/store';

import { generateRandomString } from 'src/lib/crypto';
import { getEnvironment } from 'src/lib/featureFlags';
import { localStorage } from 'src/lib/localStorage';

const REDIRECT_URI = `${window.location.protocol}//${window.location.host}/integration-jira-ui/oauth/callback`;

type SessionInfo = {
  loading: boolean,
  loggedIn: boolean,
  accountDomain: ?string,
  environment: {
    apiBaseUrl: ?string,
    accountBaseUrl: ?string,
  },
  error: ?any
}

export const login = () => {
  if (getEnvironment().curityLogin) {
    openCurityPopup();
    return;
  }

  localStorage.setItem('integration_jira_oauth_state', generateRandomString(40));
  localStorage.setItem('integration_jira_oauth_current_client', new URLSearchParams(window.location.search).get('clientKey'));

  const state = localStorage.getItem('integration_jira_oauth_state');
  const oAuthUrl = `${getEnvironment().appBaseUrl}/oauth/authorize?client_id=${getEnvironment().oauthClientId}&redirect_uri=${REDIRECT_URI}&state=${state}`;
  window.open(oAuthUrl, 'popup', 'width=600,height=600');
};

export const logout = () => {
  deleteSession();
  localStorage.setItem('integration_jira_oauth_state', undefined);
};

export const useSession = () : SessionInfo => useSelector(state => state.session);
export const getSession = () : SessionInfo => store.getState().session;
